// extracted by mini-css-extract-plugin
export var container = "_vq-0";
export var table = "_vq-2";
export var tableWrapper = "_vq-1";